import React from 'react'
import { useTranslation } from 'react-i18next';
import { Row, Col, Badge, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { Payment } from '../../models';
import Icon from '@mdi/react';
import {
    mdiCashSync,
    mdiCashPlus,
    mdiCreditCardPlusOutline,
    mdiBankTransferIn,
    mdiBankTransferOut,
    mdiCheckbook
} from '@mdi/js';

import './PaymentListItem.css';

export default ({ payment, index, actions, className, condensed }) => {
    const { t } = useTranslation();

    if (condensed)
        className = (className || '') + ' condensed';

    const icon = React.useMemo(() => {
        switch (payment?.mode) {
            case Payment.MODE_CASH:
                return mdiCashPlus;
            case Payment.MODE_CARD:
                return mdiCreditCardPlusOutline;
            case Payment.MODE_TRANSFER:
                return mdiBankTransferOut;
            case Payment.MODE_DEBIT:
                return mdiBankTransferIn;
            case Payment.MODE_CHECK:
                return mdiCheckbook;
        }
    }, [payment]);

    if (!payment)
        return null;

    return (
        <Card className={ `PaymentListItem ${className}` }>
            <CardBody>
                <Row className="mb-0">
                    <Col className="col-auto bg-primary">
                        <CardText>
                            <Icon path={ icon } size={1} color="white" />&nbsp;
                        </CardText>
                    </Col>
                    <Col>
                        <CardText>
                            {t(`payments.mode_${payment.mode}`)} ({t('payments.by_x_times', { x: payment.nb})})
                        </CardText>
                    </Col>
                    <Col>
                        <CardText>
                            { payment.created_at.format('LL') }
                        </CardText>
                    </Col>
                    <Col>
                        <CardText>
                            <strong>{ payment.formatAmount() }</strong>
                        </CardText>
                    </Col>
                    { actions && (
                    <Col className="col-auto">
                        <div className="actions">
                            { actions }
                        </div>
                    </Col>
                    )}
                </Row>
            </CardBody>
        </Card>
    )
}
